(ns ycweb.app.website.cart.cart
  (:require
   [rum.core :as rum]
   [util.string :as str]
   [ycweb.app.website.cart.model :as model]
   [ycweb.app.website.cart.pages.cart-items]
   [ycweb.app.website.cart.pages.cart-later]
   [ycweb.app.website.cart.pages.delivery-method]
   [ycweb.app.website.cart.pages.details-address]
   [ycweb.app.website.cart.pages.details-billing]
   [ycweb.app.website.cart.pages.details-giftmessage]
   [ycweb.app.website.cart.pages.details-instructions]
   [ycweb.app.website.cart.pages.details-newsletter]
   [ycweb.app.website.cart.pages.empty :as empty]
   [ycweb.app.website.cart.pages.order-confirmation]
   [ycweb.app.website.cart.pages.payment-capture]
   [ycweb.app.website.cart.pages.payment-method]
   [ycweb.app.website.cart.pages.reject-saved]
   [ycweb.app.website.cart.parts.common :as cart.common]
   [ycweb.app.website.cart.parts.header :as cart.header]
   #_[ycweb.app.website.cart.parts.modals]
   [ycweb.app.website.cookiebanner.cookiebanner :as cookiebanner]
   [ycweb.components.appcommon :as appcommon]
   [ycweb.components.buttons :as buttons]
   [ycweb.components.common :as cmn]
   [ycweb.components.feedback :as feedback]
   [ycweb.components.flow :as flow]
   [ycweb.components.grid :as grid]
   [ycweb.components.headings :as headings]
   [ycweb.components.toaster :as toaster]
   [ycweb.components.transitions :as t]
   [ycweb.util.core :as u]
   [ycweb.util.urlstate :as urlstate]))

(rum/defc dialog-items-discontinued []
  [:div {:class "yc-popup u-max-width-480 mfp-hide js-order-items-discontinued"}
   [:h2 {:class "yc-heading yc-heading--small"} "You have unavailable items in your cart"]
   [:p {:class "yc-paragraph"} "Some of the products in your cart have been discontinued or are unavailable. Please remove them from your order to continue checking out."]])

;; --- Cart Components ---

(def scroll-on-step-change
  {:did-mount
   (fn [state]
     (let [[_ process-atom _] (:rum/args state)]
       (assoc state ::prev-step (get @process-atom :step))))
   :did-update
   (fn [state]
     (let [[_ process-atom _] (:rum/args state)
           step (get @process-atom :step)]
       #?(:cljs
          (when (and (::prev-step state) (not= step (::prev-step state)))
            (.scrollTo js/window 0 0)))
       (assoc state ::prev-step step)))})

(def dismiss-notices-on-step-one
  "Drop transient voucher notices when a checkout journey starts cleanly at
   step 1 (screen mount, or returning from payment-capture). Mid-journey
   back-navigation keeps them."
  {:did-mount
   (fn [state]
     (let [[app-atom process-atom _] (:rum/args state)
           step (get @process-atom :step)]
       (when (contains? #{:cart/items nil} step)
         (model/clear-voucher-notices! app-atom))
       (assoc state ::notices-step step)))
   :did-update
   (fn [state]
     (let [[app-atom process-atom _] (:rum/args state)
           step (get @process-atom :step)]
       (when
         (and
           (= step :cart/items)
           (= (::notices-step state) :payment/capture))
         (model/clear-voucher-notices! app-atom))
       (assoc state ::notices-step step)))})

(rum/defc cart-view < rum/reactive cmn/cursors scroll-on-step-change dismiss-notices-on-step-one
  [app-atom process-atom cart-summary-atom]

  (let [step-info (cart.common/current-step-info process-atom)
        step-number (:step step-info)]
    (list
      (rum/with-key
        (cart.header/checkout-header app-atom process-atom cart-summary-atom)
        "checkout-header")
      [:div {:key "checkout-content" :class (u/bem :yc-page-content [:standard])}
       (cart.header/checkout-step-title app-atom process-atom)
       (cart.header/step-buttons-view app-atom process-atom)

       [:div#cart_checkout
        (cart.common/voucher-notices-banner app-atom)
        (cart.common/checkout-step app-atom process-atom cart-summary-atom)
        (dialog-items-discontinued)]

       [:div.clearer]])))

(rum/defc empty-cart-view < rum/reactive
  "Displays a message and suggestions when the cart is empty."
  [app-atom process-atom cart-summary-atom]
  (list
    (rum/with-key
      (cart.header/checkout-header app-atom process-atom cart-summary-atom)
      "checkout-header")
    [:div {:key "checkout-content" :class (u/bem :yc-page-content [:standard])}
     (cart.header/checkout-step-title app-atom process-atom)
     (cart.header/step-buttons-view app-atom process-atom)

     [:div#cart_checkout
      (empty/empty-cart-view app-atom process-atom cart-summary-atom)
      (dialog-items-discontinued)]

     [:div.clearer]]))

(defn insert-old-url
  "Constructs a URL with version information from Redis.
   Takes a config map with :file and :type keys."
  [config]
  (let [v (rand-int 100000000)
        v-with-dot (if (not-empty v) (str v ".") "")]
    (str (:file config) "." v-with-dot (:type config))))

(rum/defcs dev-cart-dialog-body < rum/reactive
  (rum/local
    {:is-registry? false
     :has-bundles? false
     :has-special-items? false
     :has-email-deliveries? false
     :has-physical-items? true
     :delivery-fee-applicable? true
     :has-staff-discount? false
     :has-trade-discount? false
     :has-vouchers? false
     :item-count 1
     :country-code "ZA"
     :country-name "South Africa"}
    ::local)
  [s app-atom _ _]
  #?(:cljs
     (let [state-atom (::local s)
           state (rum/react state-atom)]
       [:div {:class "yc-popup u-max-width-600"}
        [:h2 {:class "yc-heading yc-heading--small"} "Development Cart Generator"]
        [:div {:class "yc-form"}
         [:div {:class "yc-form-group"}
          [:label {:class "yc-label"} "Cart Type"]
          [:div {:class "yc-checkbox-group"}
           [:label {:class "yc-checkbox"}
            [:input {:type "checkbox"
                     :checked (:is-registry? state)
                     :on-change #(swap! state-atom assoc :is-registry? (.. % -target -checked))}]
            "Registry Cart"]]
          [:div {:class "yc-checkbox-group"}
           [:label {:class "yc-checkbox"}
            [:input {:type "checkbox"
                     :checked (:has-bundles? state)
                     :on-change #(swap! state-atom assoc :has-bundles? (.. % -target -checked))}]
            "Has Bundles"]]
          [:div {:class "yc-checkbox-group"}
           [:label {:class "yc-checkbox"}
            [:input {:type "checkbox"
                     :checked (:has-special-items? state)
                     :on-change #(swap! state-atom assoc :has-special-items? (.. % -target -checked))}]
            "Has Special Items"]]
          [:div {:class "yc-checkbox-group"}
           [:label {:class "yc-checkbox"}
            [:input {:type "checkbox"
                     :checked (:has-email-deliveries? state)
                     :on-change #(swap! state-atom assoc :has-email-deliveries? (.. % -target -checked))}]
            "Has Email Deliveries"]]
          [:div {:class "yc-checkbox-group"}
           [:label {:class "yc-checkbox"}
            [:input {:type "checkbox"
                     :checked (:has-physical-items? state)
                     :on-change #(swap! state-atom assoc :has-physical-items? (.. % -target -checked))}]
            "Has Physical Items"]]]

         [:div {:class "yc-form-group"}
          [:label {:class "yc-label"} "Discounts"]
          [:div {:class "yc-checkbox-group"}
           [:label {:class "yc-checkbox"}
            [:input {:type "checkbox"
                     :checked (:has-staff-discount? state)
                     :on-change #(swap! state-atom assoc :has-staff-discount? (.. % -target -checked))}]
            "Staff Discount"]]
          [:div {:class "yc-checkbox-group"}
           [:label {:class "yc-checkbox"}
            [:input {:type "checkbox"
                     :checked (:has-trade-discount? state)
                     :on-change #(swap! state-atom assoc :has-trade-discount? (.. % -target -checked))}]
            "Trade Discount"]]
          [:div {:class "yc-checkbox-group"}
           [:label {:class "yc-checkbox"}
            [:input {:type "checkbox"
                     :checked (:has-vouchers? state)
                     :on-change #(swap! state-atom assoc :has-vouchers? (.. % -target -checked))}]
            "Has Vouchers"]]]

         [:div {:class "yc-form-group"}
          [:label {:class "yc-label"} "Delivery"]
          [:div {:class "yc-checkbox-group"}
           [:label {:class "yc-checkbox"}
            [:input {:type "checkbox"
                     :checked (:delivery-fee-applicable? state)
                     :on-change #(swap! state-atom assoc :delivery-fee-applicable? (.. % -target -checked))}]
            "Delivery Fee Applicable"]]]

         [:div {:class "yc-form-group"}
          [:label {:class "yc-label"} "Item Count"]
          [:input {:type "number"
                   :min 1
                   :max 10
                   :value (:item-count state)
                   :on-change #(swap! state-atom assoc :item-count (js/parseInt (.. % -target -value)))}]]

         [:div {:class "yc-form-group"}
          [:label {:class "yc-label"} "Country"]
          [:select {:value (:country-code state)
                    :on-change #(let [code (.. % -target -value)]
                                  (swap! state-atom assoc
                                    :country-code code
                                    :country-name (case code
                                                    "ZA" "South Africa"
                                                    "US" "United States"
                                                    "GB" "United Kingdom"
                                                    "AU" "Australia"
                                                    "Other")))}
           [:option {:value "ZA"} "South Africa"]
           [:option {:value "US"} "United States"]
           [:option {:value "GB"} "United Kingdom"]
           [:option {:value "AU"} "Australia"]
           [:option {:value "Other"} "Other"]]]

         #_[:div {:class "yc-form-actions"}
            (buttons/button-web "Generate Test Cart"
              {:style :dark
               :on-click #(let [cart-data (cart.sample/make-test-cart
                                            :is-registry? (:is-registry? state)
                                            :has-bundles? (:has-bundles? state)
                                            :has-special-items? (:has-special-items? state)
                                            :has-email-deliveries? (:has-email-deliveries? state)
                                            :has-physical-items? (:has-physical-items? state)
                                            :delivery-fee-applicable? (:delivery-fee-applicable? state)
                                            :country {:code (:country-code state)
                                                      :name (:country-name state)}
                                            :has-staff-discount? (:has-staff-discount? state)
                                            :has-trade-discount? (:has-trade-discount? state)
                                            :has-vouchers? (:has-vouchers? state)
                                            :item-count (:item-count state))]
                            (swap! app-atom assoc :cart-summary cart-data)

                            (grid/close-modal app-atom))})]]])))

;; --- Checkout-Specific Layout ---

(rum/defc checkout-screen-wrapper <
  rum/reactive
  {:will-mount
   (fn [state]
     #?(:cljs
        (when-let [body (js/document.querySelector "body")]
          (set! (.-className body) "checkout-body")))
     state)
   :did-mount
   (fn [state]
     #?(:cljs
        (when-let [body (js/document.querySelector "body")]
          (set! (.-className body) "checkout-body")))
     state)
   :did-update
   (fn [state]
     #?(:cljs
        ;; Ensure checkout-body class is maintained on updates
        (when-let [body (js/document.querySelector "body")]
          (set! (.-className body) "checkout-body")))
     state)
   :will-unmount
   (fn [state]
     #?(:cljs
        ;; Reset body class when component unmounts
        (when-let [body (js/document.querySelector "body")]
          (set! (.-className body) "")))
     state)}
  [app-atom component opts]
  "Checkout-specific layout that replaces normal site header/footer with checkout layout"
  (list
    (rum/with-key (cookiebanner/cookiebanner app-atom) "cookiebanner")
    (rum/with-key component "checkout-component")
    (rum/with-key (toaster/loading-overlay app-atom :web.cart/loading) "loading-overlay")))

(rum/defc cart-page <
  rum/reactive
  cmn/cursors
  {:did-mount
   (fn [state]
     (let [[app-atom] (:rum/args state)
           summary (get-in @app-atom [:cart-summary])]
       (model/fire-checkout-step-1-once! app-atom summary)
       #?(:cljs
          (let [link-uuid (.get (js/URLSearchParams. (.. js/window -location -search)) "cart_uuid")]
            (when (and link-uuid (= link-uuid (str (get-in summary [:cart :cart_uuid]))))
              (model/set-cart-uuid app-atom link-uuid)))))
     state)
   :will-mount
   (fn [state]
     ;; Load cart data on mount if cart is not set or empty
     (let [[app-atom process-atom]  (:rum/args state)
           cart (get-in @app-atom [:cart-summary])
           cart-items (get-in cart [:items])
           ;; Get screen parameters to check for order parameters
           screen-params (cmn/screen-params app-atom)
           orderid (:orderid screen-params)]

       (println "Screen params:" (pr-str screen-params))
       (swap! process-atom update-in [:step]
         (fn [step]
           (if (nil? step) :cart/items step)))

       ;; Check if we have order parameters for order summary
       (cond
         orderid
         (do
           (println "Loading order summary for order:" orderid)
           (toaster/open-overlay app-atom :web.cart/loading "Loading order...")
           (model/fetch-order-summary app-atom orderid
             (:h screen-params) (:method screen-params)))

         (or (nil? cart) (empty? cart-items))
         (do
           (println "Cart not loaded or empty, loading cart data...")
           (toaster/open-overlay app-atom :web.cart/loading "Loading cart...")
           (model/load-cart-data app-atom nil {:refresh-specials? true}))))
     state)}
  [app-atom process-atom]
  "Main cart component, conditionally renders empty or populated cart view."
  (let [cart-summary-atom (cmn/cursor-in app-atom [:cart-summary])
        step-info (cart.common/current-step-info process-atom)]
    [:<>
     (cond
       (and
         (zero? (count (cmn/curact cart-summary-atom [:items])))
         (not (:ignore-empty-cart? step-info)))

       (empty-cart-view app-atom process-atom cart-summary-atom)

       :else
       (cart-view app-atom process-atom cart-summary-atom))]))

(defn bind-url [app-atom]
  (let [process-atom (cmn/process-cursor app-atom)
        screen-params (cmn/screen-params app-atom)

        step-from-url (get screen-params :step)
        valid-step? (contains? (set (keys cart.common/step-def)) (keyword step-from-url))
        initial-step
        (if (and step-from-url valid-step?)
          (keyword step-from-url)
          :cart/items)]

      ;; Set the step based on URL parameter or default
    (swap! process-atom assoc :step initial-step)
    (urlstate/bind-nav-fragment (rum/cursor-in process-atom [:step]) :step :keyword)))

(defmethod t/transition-open :web.order/ShowCart [app-atom screen screen-params]
  (let [process-atom (cmn/process-cursor app-atom)
        _ (urlstate/bind-nav-fragment (rum/cursor-in process-atom [:step]) "step" :keyword)
        ;; Extract step from URL parameters, default to :cart/items
        step-from-url (get screen-params :step)
        valid-step? (contains? (set (keys cart.common/step-def)) (keyword step-from-url))

        initial-step
        (if (and step-from-url valid-step?)
          (keyword step-from-url)
          :cart/items)

        ;; Extract substep parameter for payment flows
        substep-from-url (get screen-params :substep)]

    (when
      (and
        (not (:orderid screen-params))
        (or
          (:cart_uuid screen-params)
          (not (:cart-summary @app-atom))))
      (toaster/open-overlay app-atom :web.cart/loading "Loading cart...")
      (swap! app-atom dissoc :cart-summary)
      (model/load-cart-data app-atom nil {:refresh-specials? true}))

    (when (:orderid screen-params)
      (toaster/open-overlay app-atom :web.cart/loading "Loading order...")
      (model/fetch-order-summary app-atom
        (:orderid screen-params) (:h screen-params)
        (:method screen-params)))

    (cond
      (:declined screen-params)
      (toaster/open-toast app-atom :error
        "Payment declined — please try again or choose a different payment method."
        {:closetime 8000 :show-close-button true})

      (:cancelled screen-params)
      (toaster/open-toast app-atom :warning
        "Payment cancelled — please choose a payment method to continue."
        {:closetime 8000 :show-close-button true})

      (:pending screen-params)
      (toaster/open-toast app-atom :info
        "We're still confirming your payment with the provider. If it goes through we'll update your order — otherwise choose a payment method below."
        {:closetime 12000 :show-close-button true}))

    ;; Initialize substep(s) if present (for payment return flows)
    ;; Supports CSV format: substep=return,success
    (when substep-from-url
      (cart.common/clear-substeps process-atom)
      (let [substeps
            (->>
              (if (string? substep-from-url)
                (str/split substep-from-url #",")
                [substep-from-url])
              (remove nil?))]
        (doseq [substep substeps]
          (cart.common/push-substep process-atom
            (keyword
              (str/trim substep))))))

    ;; Set the step based on URL parameter or default
    #_(swap! process-atom assoc :step initial-step)

    ;; Bind the step parameter to URL for two-way sync
    #_(urlstate/bind-nav-fragment (rum/cursor-in process-atom [:step]) "step" :keyword)))

(defmethod flow/render-screen :web.order/ShowCart [app-atom _]
  (checkout-screen-wrapper app-atom
    (cart-page app-atom (cmn/process-cursor app-atom))
    {}))

(defmethod t/transition-open :web.order/paymentoptions [app-atom screen screen-params]
  (let [process-atom (cmn/process-cursor app-atom)
        _ (urlstate/bind-nav-fragment (rum/cursor-in process-atom [:step]) "step" :keyword)
        ;; Extract step from URL parameters, default to :cart/items
        step-from-url (:step @process-atom)
        valid-step? (contains? (set (keys cart.common/step-def)) (keyword step-from-url))
        _ (println "Step from URL:" step-from-url)
        _ (println "Valid step?" valid-step?)
        initial-step
        (cond
          ;; If step is specified and valid, use it
          (and step-from-url valid-step?)
          (keyword step-from-url)

          ;; Default to payment capture
          :else
          :payment/capture)]

    (swap! process-atom assoc :step initial-step)

;; Check if we have order parameters for order summary
    (cond
      (:id screen-params)
      (do
        (toaster/open-overlay app-atom :web.cart/loading "Loading order...")
        (model/fetch-order-summary app-atom (:id screen-params) (:h screen-params)
          (:method screen-params)))

      (:cart_uuid screen-params)
      (do
        (toaster/open-overlay app-atom :web.cart/loading "Loading cart...")
        (swap! app-atom dissoc :cart-summary)
        (model/load-cart-data app-atom nil {:refresh-specials? true}))

      :else
      (do
        (toaster/open-overlay app-atom :web.cart/loading "Loading cart...")
        (model/load-cart-data app-atom nil {:refresh-specials? true})))

    ;; Set the step based on URL parameter or default
    #_(swap! process-atom assoc :step initial-step)

    ;; Bind the step parameter to URL for two-way sync
    #_(urlstate/bind-nav-fragment (rum/cursor-in process-atom [:step]) "step" :keyword)))

(defmethod flow/render-screen :web.order/paymentoptions [app-atom _]
  (checkout-screen-wrapper app-atom
    (cart-page app-atom (cmn/process-cursor app-atom))
    {}))
;; ========= Cart Modal Configurations ===========================

;; Voucher redemption modal component
(rum/defc redeem-voucher-modal-body < rum/reactive cmn/cursors
  [app-atom config]
  (let [voucher-payments (model/payment-type-list (rum/react (cmn/cursor-in app-atom [:cart-summary])) "Voucher")
        has-vouchers? (not (empty? voucher-payments))
        modal-config (get-in (rum/react app-atom) [:modal :config])
        loading? (get-in (rum/react app-atom) [:toaster :overlay :web.cart/redeem-voucher :open?])
        fb (:voucher-feedback modal-config)
        removing-uuid (:removing-voucher-uuid modal-config)]

    [:div
     ;; Error/success feedback
     (when fb
       (rum/with-key
         (feedback/feedback (:type fb) (:message fb) nil)
         "voucher-feedback"))

     (cart.common/voucher-notices-banner app-atom)

     ;; Instructions
     [:p {:class "yc-paragraph"}
      "Type in your voucher code, hit the 'Redeem voucher' button and the voucher value will be deducted from your order."]

     ;; Voucher input form
     [:div {:class "form-field"}
      [:label {:class "form-label"} "Voucher number:"]
      [:input {:type "text"
               :class "text-input js-text-input js-button-input-trigger js-voucher-input"
               :placeholder "Voucher no. e.g. 123456789"
               :id "voucher-input-field"
               :disabled loading?}]
      [:div {:class "form-hint-wrapper"}
       [:span {:class "form-hint js-form-hint"} "Enter your voucher code here"]]]

     ;; Claimed vouchers list
     (let
       [removing-data (:removing-voucher-data modal-config)
        all-vouchers
        (if (and removing-uuid removing-data
              (not (some #(= (:payment_uuid %) removing-uuid) voucher-payments)))
          (conj (vec voucher-payments) removing-data)
          voucher-payments)]
       (when (seq all-vouchers)
         [:section {:class "cart-item-list cart-item-list--is-group u-margin-bottom-24"}
          [:p {:class "yc-paragraph"} [:b "Claimed vouchers:"]]
          (for [voucher all-vouchers
                :let
                [v-uuid (:payment_uuid voucher)
                 removing? (= v-uuid removing-uuid)]]
            [:article
             {:key v-uuid
              :data-voucher-uuid v-uuid
              :class (str "card card--no-hover cart-voucher"
                       (when removing? " card--pulse-minus"))
              :style (when removing?
                       {:animation-fill-mode "forwards"})}
             [:h2 {:class "cart-voucher__title"}
              "Voucher: "
              [:span {:class "u-text-monospace"}
               (let [code (str (or (:code voucher) (:reference voucher)))]
                 (->> (partition-all 3 code) (map #(apply str %)) (str/join "-")))]]
             [:p {:class "cart-voucher__value"}
              [:span {:class "u-text-red"} "-R" (u/currency-format (or (:amount voucher) 0))]]
             [:a {:href "#"
                  :class "cart-voucher__button icon-link icon-block-link"
                  :on-click #(grid/open-modal app-atom :cart/delete-voucher {:voucher-data voucher})}
              [:i {:class "icon icon--inline icon--is-dark icon--delete"}]
              [:span {:class "u-hidden-from-view"} "Remove"]]])]))

     ;; Loading overlay
     (toaster/loading-overlay app-atom :web.cart/redeem-voucher)]))

;; Voucher redemption modal footer
(rum/defc redeem-voucher-modal-footer < rum/reactive cmn/cursors
  [app-atom config]
  (let [loading? (get-in (rum/react app-atom) [:toaster :overlay :web.cart/redeem-voucher :open?])
        captcha-site-key (cmn/curact app-atom [:config :captcha-site-key])]
    (grid/button-row
      {:left-text "Cancel"
       :left-fn #(grid/close-modal app-atom)
       :left-no-icon true
       :left-disabled? loading?
       :right-text "Redeem voucher"
       ;; Run invisible reCAPTCHA, then dispatch the redeem with the captcha-token.
       ;; dispatch-action (used by recaptcha) doesn't close the modal, matching the
       ;; previous :prevent-closing behaviour.
       :right-fn #(appcommon/recaptcha app-atom captcha-site-key :cart/redeem-voucher-confirmed {})
       :right-disabled? loading?})))

(defmethod grid/modal-config :cart/redeem-voucher [_ _ config]
  {:header "Redeem a voucher"
   :body redeem-voucher-modal-body
   :footer redeem-voucher-modal-footer
   :modal-type :variable})

;; Delete voucher modal footer
(rum/defc delete-voucher-modal-footer < rum/reactive cmn/cursors
  [app-atom config]
  (let [loading? (get-in (rum/react app-atom) [:modal :config :voucher-loading] false)]
    (grid/button-row
      {:left-text "Cancel"
       :left-fn #(grid/open-modal app-atom :cart/redeem-voucher {})
       :left-no-icon true
       :left-disabled? loading?
       :right-text "Yes, remove it"
       :right-style :negative
       :right-fn #(grid/dispatch-modal-action app-atom :cart/remove-voucher-confirmed nil {:prevent-closing true})
       :right-disabled? loading?})))

(defmethod grid/modal-config :cart/delete-voucher [_ _ config]
  {:header "Delete voucher"
   :body
   (fn [app-atom _ _]
     [:div
      [:p {:class "yc-paragraph"}
       "Are you sure you want to remove this voucher from your order? There is no way to undo this action."]])
   :footer delete-voucher-modal-footer
   :modal-type :variable})

(rum/defc save-for-later-modal-body < rum/reactive cmn/cursors
  [app-atom config]
  [:div
   [:p {:class "yc-paragraph"}
    "Keen to check out later or on another device? We'll save your cart for you and email you a reminder link."]])

(rum/defc save-for-later-modal-footer < rum/reactive cmn/cursors
  [app-atom config]
  (grid/button-row
    {:left-text "Cancel"
     :left-fn #(grid/close-modal app-atom)
     :left-no-icon true
     :right-text "Yes, continue"
     :right-fn #(grid/dispatch-modal-action app-atom :cart/save-for-later-confirmed)}))

(defmethod grid/modal-config :cart/save-for-later [_ _ config]
  {:header "Save cart for later"
   :body save-for-later-modal-body
   :footer save-for-later-modal-footer
   :modal-type :variable})

;; ========= Cart Modal Action Handlers ===========================

(defmethod grid/action :cart/remove-item-confirmed [app-atom config action-key]
  "Handle confirmed item removal from cart"
  (let [item-data (:item-data config)]
    (println "Removing item from cart:" item-data)
    ;; TODO: Implement actual item removal logic
    ;; This would typically call model/remove-item-from-cart or similar
    (grid/close-modal app-atom)))

(defmethod grid/action :cart/move-to-wishlist [app-atom {:keys [cartitem_uuids variation_uuid groupnumber]} _]
  "Handle confirmed item move to wishlist"
  (when cartitem_uuids
    (if groupnumber
      (model/remove-bundle-from-cart-wishlist app-atom cartitem_uuids groupnumber)
      (model/move-item-to-wishlist app-atom cartitem_uuids variation_uuid))))

(defmethod grid/action :cart/redeem-voucher-confirmed [app-atom config action-key]
  "Handle confirmed voucher redemption"
  #?(:cljs
     (let [voucher-input (.getElementById js/document "voucher-input-field")
           voucher-code (when voucher-input (.-value voucher-input))
           captcha-token (:captcha-token config)]
       (cond
         (str/blank? voucher-code)
         (grid/update-modal-config app-atom :cart/redeem-voucher
           {:voucher-feedback {:type :error :message "Please enter a voucher code."}})

         :else
         (do
           (grid/update-modal-config app-atom :cart/redeem-voucher
             {:voucher-feedback nil})
           (toaster/open-overlay app-atom :web.cart/redeem-voucher "Redeeming voucher...")

           (model/apply-voucher-payment app-atom voucher-code nil captcha-token
             (fn [response]
               (toaster/close-overlay app-atom :web.cart/redeem-voucher)
               (grid/update-modal-config app-atom :cart/redeem-voucher
                 {:voucher-feedback
                  (if (:success response)
                    {:type :success :message "Voucher redeemed successfully!"}
                    {:type :error
                     :message (or (:msg response)
                                "Sorry, we couldn't find that voucher code. Please check that you entered it correctly.")})})
               (when (and (:success response) voucher-input)
                 (set! (.-value voucher-input) "")))))))
     :clj nil))

(defmethod grid/action :cart/remove-voucher-confirmed [app-atom config action-key]
  "Handle confirmed voucher removal"
  (let [voucher-data (:voucher-data config)]
    (when-let [payment-uuid (:payment_uuid voucher-data)]
      (grid/open-modal app-atom :cart/redeem-voucher {})
      (toaster/open-overlay app-atom :web.cart/redeem-voucher "Removing voucher...")
      (model/remove-payment app-atom payment-uuid
        (fn [response]
          (toaster/close-overlay app-atom :web.cart/redeem-voucher)
          (grid/update-modal-config app-atom :cart/redeem-voucher
            {:removing-voucher-uuid payment-uuid
             :removing-voucher-data voucher-data})
          #?(:cljs
             (js/setTimeout
               (fn []
                 (when-let [elem (.querySelector js/document
                                   (str "[data-voucher-uuid='" payment-uuid "']"))]
                   (let [height (.-offsetHeight elem)]
                     (set! (.. elem -style -height) (str height "px"))
                     (set! (.. elem -style -overflow) "hidden")
                     (set! (.. elem -style -transition) "height 0.25s ease-out, padding 0.25s ease-out, opacity 0.25s ease-out")
                     (js/requestAnimationFrame
                       (fn []
                         (set! (.. elem -style -height) "0px")
                         (set! (.. elem -style -padding) "0px")
                         (set! (.. elem -style -opacity) "0")))))
                 (js/setTimeout
                   (fn []
                     (grid/update-modal-config app-atom :cart/redeem-voucher
                       {:removing-voucher-uuid nil
                        :removing-voucher-data nil}))
                   500))
               2000)))))
    (when-not (:payment_uuid voucher-data)
      (grid/open-modal app-atom :cart/redeem-voucher {}))))

(defmethod grid/action :cart/save-for-later-confirmed [app-atom config action-key]
  (grid/close-modal app-atom)
  (let [process-atom (cmn/process-cursor app-atom)
        cart-summary-atom (rum/cursor-in app-atom [:cart-summary])
        user (:user @cart-summary-atom)
        user-name (str/trim (str (:firstname user) " " (:lastname user)))
        user-email (:email user)]
    (cond
      ;; A save is already in flight (the link can be clicked again)
      (:submitting? @process-atom)
      nil

      (and
        (not (:guest user))
        (not (str/blank? user-name))
        (not (str/blank? user-email)))
      (model/save-cart-later app-atom {:name user-name :email user-email}
        (fn [response]
          (when (:success response)
            (cart.common/navigate-to-step app-atom process-atom cart-summary-atom :cart/saved)
            (model/set-cart-uuid app-atom nil)
            (reset! cart-summary-atom {}))))

      :else
      (cart.common/navigate-to-step app-atom process-atom cart-summary-atom :cart/save-for-later))))

;; ========= Existing Modal and Action Definitions ===========================

(defmethod grid/action :dev-cart/close-popup [app-atom _ _]
  (grid/close-modal app-atom))

(defmethod grid/modal-config :dev-cart/generator [_ _ _]
  {:body dev-cart-dialog-body
   :modal-type :variable
   :cancel-key :dev-cart/close-popup})

(defmethod grid/action :web.cart/claim-voucher [app-atom config]
  (println "claim voucher" config)
  (let [voucher-code (:vouchertext config)
        voucher-text-atom (rum/cursor-in app-atom [:cart :vouchertext])]
    (when (u/presence voucher-code)
      (model/apply-voucher-payment app-atom voucher-code nil (:captcha-token config)
        (fn [response]
          ;; Complete callback - reset the form on success
          (println "Voucher claim complete")
          (toaster/close-overlay app-atom :web.cart/claim-voucher)
          (reset! voucher-text-atom ""))))))